import { gql } from '@apollo/client';

export const DOWNLOAD_LABEL = gql`
  query DownloadParcelLabel($labelId: String!, $format: String!) {
    downloadParcelLabel(labelId: $labelId, format: $format)
  }
`;
